import { Box, Modal } from "@mui/material";
import { Button, IconButton } from "@repo/ui";
import { styled } from "@mui/material/styles";

export const StyledModalContainer = styled(Modal)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const StyledContentBox = styled(Box)(({ theme }) => {
  return {
    backgroundColor: theme.colors.white,
    outline: "none",
    padding: "30px 20px",
    position: "relative",
    textAlign: "center",
    width: "85%",

    [theme.breakpoints.up("md")]: {
      maxWidth: 625,
      padding: "40px 60px",
      textAlign: "left",
    },
  };
});

export const StyledButton = styled(Button)(({ theme }) => {
  return {
    margin: "30px auto 0",
    maxWidth: 128,
    width: "100%",

    [theme.breakpoints.up("md")]: {
      margin: "55px 0px 20px",
      textAlign: "left",
    },
  };
});

export const StyledIconButton = styled(IconButton)(({ theme }) => {
  return {
    color: theme.colors.black,
    cursor: "pointer",
    minWidth: "auto",
    padding: 5,
    position: "absolute",
    right: 10,
    transform: "scale(0.8)",
    top: 10,
  };
});
